import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const LeafIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M21.04,1h.04s.04,0,.04,0c.08,0,.15.03.22.05.14.05.27.13.37.23.01.01.02.02.03.03h0s0,0,0,0l.03.03.05.06h0s0,0,0,0c.06.08.1.17.13.26.03.09.05.19.05.3v.06s0,.02,0,.02h0s0,.01,0,.01l-.35,4.54c-.13,1.43-.37,3.11-.78,4.82-.69,2.92-1.7,5.24-3.16,6.7-3.48,3.48-8.48,3.82-12.17.83l-.08-.07h0c-.48.68-.87,1.29-1.17,1.82-.06.1-.11.19-.15.27l-.11.21-.1.2c-.23.5-.82.73-1.32.5-.5-.23-.73-.82-.5-1.32.27-.59.88-1.66,1.94-3.13-2.98-3.69-2.64-8.68.84-12.16,1.45-1.46,3.78-2.47,6.7-3.16,1.88-.45,3.73-.7,5.24-.81l4.11-.32h.03s.02,0,.02,0h.02s.02,0,.02,0h.04ZM6.66,17.27c1.56-2,3.55-4.19,6.03-6.55.4-.38.42-1.01.04-1.41-.38-.4-1.01-.42-1.41-.04-2.45,2.33-4.45,4.51-6.04,6.52-2-2.83-1.64-6.45,1-9.09,1.13-1.13,3.16-2.01,5.74-2.63,1.59-.38,3.16-.61,4.49-.73l3.4-.27-.23,2.96c-.11,1.42-.34,3.17-.76,4.93-.61,2.59-1.5,4.61-2.63,5.74-2.76,2.76-6.57,3.02-9.46.72l-.18-.18Z"
    />
  </svg>
)

export const LeafFilledIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path d="M3.02808 19.0049L3.0984 19.083L4.45582 20.4404C3.97582 21.1264 3.58669 21.7368 3.28101 22.2666C3.22296 22.3672 3.17135 22.4582 3.12672 22.5391L3.01246 22.752L2.9109 22.9561C2.68279 23.459 2.0896 23.6811 1.58668 23.4531C1.08388 23.2249 0.861501 22.6328 1.08961 22.1299C1.3587 21.5367 1.97124 20.4736 3.02418 19L3.02808 19.0049Z" />
    <path d="M21.0027 1.00098H21.0378L21.0759 1.00488L21.115 1.00684C21.1907 1.01555 21.2647 1.03273 21.3347 1.05762C21.4763 1.10788 21.6025 1.18884 21.7058 1.29199C21.716 1.30216 21.7263 1.31264 21.7361 1.32324L21.739 1.32617L21.7644 1.3584L21.8132 1.41895L21.8162 1.42285L21.8181 1.4248C21.8736 1.50368 21.9179 1.59153 21.949 1.68555C21.9802 1.77983 21.9982 1.87994 21.9998 1.9834L21.9988 2.04785L21.9968 2.07031V2.07715L21.9959 2.08203L21.6414 6.62207C21.5158 8.04912 21.2716 9.73297 20.866 11.4424C20.1738 14.3597 19.161 16.6838 17.7058 18.1387C14.2231 21.6213 9.22944 21.9561 5.53785 18.9717L5.45972 18.9014L5.45582 18.8975C5.52522 18.7983 5.59644 18.6971 5.66968 18.5947C7.34348 16.2562 9.65042 13.613 12.6892 10.7246C13.0893 10.3441 13.1048 9.71077 12.7244 9.31055C12.3438 8.91068 11.7114 8.89505 11.3113 9.27539C8.18149 12.2503 5.79077 14.9884 4.04273 17.4307C4.03663 17.4392 4.03024 17.4476 4.02418 17.4561C1.04466 13.7654 1.38001 8.77534 4.86011 5.29395C6.31507 3.83849 8.63995 2.82601 11.5574 2.13379C13.4375 1.68772 15.2864 1.43637 16.7937 1.32422L20.9089 1.00391L20.9431 1.00098H20.9607L20.9832 1L21.0027 1.00098Z" />
  </svg>
)

export const CoinIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" fill="#FFE3B1" r="13" />
    <circle cx="13" cy="13" fill="#FFC517" r="9.75" />
    <path
      clipRule="evenodd"
      d="M10.3845 17.4236L11.0419 15.4717H15.0404L15.7055 17.4236H18.5069L14.3205 6.5H11.7539L7.58325 17.4236H10.3845ZM14.3044 13.2945H11.7769L13.021 9.60824H13.0525L14.3044 13.2945Z"
      fill="#FFE3B1"
      fillRule="evenodd"
    />
  </svg>
)

export const StarIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" fill="#D6BAF1" r="13" />
    <path
      clipRule="evenodd"
      d="M21.6312 10.4736C21.5342 10.1824 21.257 9.98546 20.9443 9.98546H15.4464L13.6851 4.81628C13.5867 4.52788 13.311 4.33331 12.9999 4.33331C12.6889 4.33331 12.4131 4.52788 12.3147 4.81628L10.5535 9.98546H5.05558C4.74279 9.98546 4.46561 10.1824 4.36864 10.4736C4.27201 10.7644 4.37781 11.0835 4.63065 11.2633L9.04732 14.4057L7.25925 19.6532C7.16051 19.9437 7.26383 20.2631 7.51527 20.4449C7.76705 20.6271 8.10947 20.6295 8.36408 20.4518L12.9999 17.2124L17.6358 20.4518C17.7613 20.5394 17.9084 20.5832 18.0554 20.5832C18.2063 20.5832 18.3569 20.537 18.4846 20.4449C18.736 20.2631 18.8393 19.9437 18.7406 19.6532L16.9527 14.4057L21.3692 11.2633C21.622 11.0835 21.7278 10.7644 21.6312 10.4736Z"
      fill="#A97ED1"
      fillRule="evenodd"
    />
  </svg>
)

export const DropIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" fill="#BBEBFF" r="13" />
    <path
      clipRule="evenodd"
      d="M19.3018 15.4395C19.3018 12.004 14.2691 6.47125 14.0547 6.23745L13.3927 5.51508L12.7307 6.23745C12.5163 6.47125 7.48364 12.004 7.48364 15.4395C7.48364 18.8742 9.91342 21.2726 13.3927 21.2726C16.872 21.2726 19.3018 18.8742 19.3018 15.4395Z"
      fill="#39C4FD"
      fillRule="evenodd"
    />
  </svg>
)
